import { effects } from 'redux-saga'

import { RECEIVE_ERROR } from 'internal-components/src/redux/modules/loading'
import { RECEIVE_OFFERS } from 'internal-components/src/redux/modules/product'
import * as signupConstants from 'internal-components/src/redux/modules/signup/constants'
import { LOGIN } from 'internal-components/src/redux/modules/authentication'

import * as constants from '../../modules/signupEdit/constants'

import advanceToAccount from './advanceToAccount'
import advanceToDetail from './advanceToDetail'
import advanceToOffer from './advanceToOffer'
import advanceToSummary from './advanceToSummary'
import applyCoupon from './applyCoupon'
import authenticate from './authenticate'
import begin from './begin'
import beginPartner from './beginPartner'
import checkEmail from './checkEmail'
import clearUser from './clearUser'
import continueSignup from './continueSignup'
import discoverTokens from './discoverTokens'
import downloadPdf from './downloadPdf'
import editSignup from './editSignup'
import filterOffers from './filterOffers'
import forget from './forget'
import handleMspOfferSelect from './handleMspOfferSelect'
import handleSubmit from './handleSubmit'
import handleSubmitHeardAbout from './handleSubmitHeardAbout'
import handleSubmitMsp from './handleSubmitMsp'
import ipn from './ipn'
import loadSignups from './loadSignups'
import remember from './remember'
import addressLookup from './addressLookup'
import qualify from './qualify'
import updateFilter from './updateFilter'
import clearQualify from './clearQualify'
import forgetAll from './forgetAll'

export default function* signupEdit(apis, { eCryptKey }) {
  yield [
    effects.takeEvery(constants.ADVANCE_TO_ACCOUNT, advanceToAccount),
    effects.takeEvery(constants.ADVANCE_TO_DETAIL, advanceToDetail, apis),
    effects.takeEvery(constants.ADVANCE_TO_OFFER, advanceToOffer),
    effects.takeEvery(constants.ADVANCE_TO_OFFER, ipn),
    effects.takeEvery(constants.ADVANCE_TO_SUMMARY, advanceToSummary, apis),
    effects.takeEvery(constants.APPLY_COUPON, applyCoupon, apis),
    effects.takeEvery(constants.AUTHENTICATE, authenticate),
    effects.takeEvery(constants.BEGIN, begin),
    effects.takeEvery(constants.BEGIN_PARTNER, beginPartner),
    effects.takeEvery(constants.CONTINUE_SIGNUP, continueSignup),
    effects.takeEvery(constants.DOWNLOAD_PDF, downloadPdf, apis),
    effects.takeEvery(constants.EDIT_SIGNUP, editSignup),
    effects.takeEvery(constants.LOAD_USER_SIGNUPS, loadSignups, apis),
    effects.takeEvery(RECEIVE_ERROR, forget),
    effects.takeEvery(LOGIN, forgetAll),
    effects.takeEvery(signupConstants.RECEIVE_SIGNUPS, discoverTokens),
    effects.takeEvery(signupConstants.RECEIVE_SIGNUPS, remember),
    effects.takeEvery(RECEIVE_OFFERS, filterOffers),
    effects.takeEvery(constants.SELECT_CLIENT, clearUser),
    effects.takeEvery(constants.SELECT_OFFER, handleMspOfferSelect),
    effects.takeLatest(constants.SET_EMAIL, checkEmail, apis),
    effects.takeEvery(constants.SUBMIT, handleSubmit, apis),
    effects.takeEvery(constants.SUBMIT_HEARD_ABOUT, handleSubmitHeardAbout, apis),
    effects.takeEvery(constants.SUBMIT_MSP, handleSubmitMsp, apis),
    effects.takeEvery(constants.UPDATE_FILTER, updateFilter),
    effects.takeEvery(constants.SET_ADDRESS_LOCID, addressLookup, apis),
    effects.takeEvery(constants.SET_ADDRESS_LOCID, clearQualify, apis),
    effects.takeEvery(constants.QUALIFY_ADDRESS, qualify, apis),
  ]
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/index.js